import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoSVG } from './ui/FormControls';
import { sbEnviarContacto } from '../services/contacto';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const CheckIconSVG = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#43B04A" />
    <path d="M6 10.2l2.4 2.4L14.5 6.5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PUNTOS = [
  "Checklists de carretillas, transpaletas y flota",
  "Firma digital integrada, sin imprimir ni escanear",
  "Descarga inmediata en PDF",
];

// ── PÁGINA PÚBLICA — Información / promoción del plan FREE ────────
export const InformacionScreen = () => {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [campoExtra, setCampoExtra] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [enviado, setEnviado] = useState(false);

  const enviarContacto = async () => {
    setError("");
    if (!nombre.trim() || !email.trim() || !mensaje.trim()) {
      setError("Rellena todos los campos.");
      return;
    }
    if (!EMAIL_REGEX.test(email.trim())) {
      setError("Introduce un email válido.");
      return;
    }
    if (mensaje.trim().length < 10) {
      setError("Cuéntanos un poco más en el mensaje.");
      return;
    }
    setLoading(true);
    try {
      await sbEnviarContacto({ nombre: nombre.trim(), email: email.trim(), mensaje: mensaje.trim(), campo_extra: campoExtra });
      setEnviado(true);
    } catch (e) {
      setError(e.message || "Error al enviar el mensaje.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-5 py-4 flex items-center justify-between">
          <button onClick={() => navigate("/")} className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: "linear-gradient(145deg,#2E9BD6,#102A46)" }}>
              <LogoSVG size={20} />
            </div>
            <span className="font-black text-[#102A46] text-lg">Ware<span className="text-[#2E9BD6]">Hause</span><span className="text-[#43B04A]">Plan</span></span>
          </button>
          <button onClick={() => navigate("/registro")} className="text-sm font-bold text-white px-4 py-2 rounded-xl bg-[#102A46] hover:bg-[#0c2036]">
            Regístrate gratis
          </button>
        </div>
      </header>

      <section className="max-w-5xl mx-auto px-5 pt-14 pb-10 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="text-4xl md:text-5xl font-black text-[#102A46] leading-tight">
            ¡Empieza ya!
          </h1>
          <p className="mt-5 text-gray-600 text-lg leading-relaxed">
            Controla carretillas, transpaletas, mantenimiento e instalaciones y flota con checklists profesionales. Rellena, firma digitalmente y descarga en PDF al instante — sin instalar nada.
          </p>
          <button onClick={() => navigate("/registro")} className="mt-7 text-base font-bold text-white px-6 py-3 rounded-xl bg-[#43B04A] hover:bg-[#399a40] shadow-lg shadow-green-100">
            Regístrate gratis
          </button>
        </div>
        <img src="/images/dashboard-hero.jpg" alt="Operario de almacén revisando inventario con un lector digital y una tablet" className="w-full aspect-[4/3] object-cover rounded-2xl" />
      </section>

      <section className="max-w-5xl mx-auto px-5 py-8">
        <div className="rounded-2xl border border-[#2E9BD6]/25 bg-[#2E9BD6]/5 px-6 py-6 md:px-8 md:py-7">
          <p className="text-[#102A46] text-lg md:text-xl font-bold leading-snug">
            Plan de mantenimiento de instalaciones completo
          </p>
          <p className="mt-1 text-gray-600">control diario, semanal y mensual</p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-5 py-8">
        <div className="rounded-2xl overflow-hidden relative">
          <img src="/images/almacen-estanterias.jpg" alt="Pasillo de estanterías industriales en un almacén logístico" className="w-full h-56 md:h-72 object-cover" />
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-5 py-8 grid sm:grid-cols-2 gap-6">
        <img src="/images/formulario-relleno.jpg" alt="Silueta de una persona revisando inventario con un portapapeles entre estanterías" className="w-full aspect-[4/3] object-cover rounded-2xl" />
        <img src="/images/pdf-firma.jpg" alt="Manos completando un checklist digital con lápiz óptico sobre una tablet" className="w-full aspect-[4/3] object-cover rounded-2xl" />
      </section>

      <section className="max-w-5xl mx-auto px-5 py-10">
        <div className="grid sm:grid-cols-3 gap-5">
          {PUNTOS.map((p) => (
            <div key={p} className="flex items-start gap-3 bg-gray-50 rounded-xl p-4">
              <div className="mt-0.5 flex-shrink-0"><CheckIconSVG /></div>
              <p className="text-gray-700 font-medium">{p}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-5 py-16 text-center">
        <button onClick={() => navigate("/registro")} className="text-lg font-bold text-white px-10 py-4 rounded-2xl bg-[#43B04A] hover:bg-[#399a40] shadow-xl shadow-green-100">
          Regístrate gratis
        </button>
      </section>

      <section className="bg-gray-50 border-t border-gray-100 py-16">
        <div className="max-w-2xl mx-auto px-5">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-black text-[#102A46]">¿Tienes dudas? Escríbenos</h2>
            <p className="mt-2 text-gray-500">Te respondemos lo antes posible.</p>
          </div>

          {enviado ? (
            <div className="bg-white border border-[#43B04A]/30 rounded-2xl p-8 text-center">
              <p className="text-[#102A46] font-bold">Mensaje enviado, te responderemos lo antes posible.</p>
            </div>
          ) : (
            <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8 space-y-4">
              <div>
                <label className="text-xs font-semibold text-gray-600 uppercase">Nombre</label>
                <input className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-[#2E9BD6]" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Tu nombre" />
              </div>
              <div>
                <label className="text-xs font-semibold text-gray-600 uppercase">Email</label>
                <input type="email" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-[#2E9BD6]" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@email.com" />
              </div>
              <div>
                <label className="text-xs font-semibold text-gray-600 uppercase">Mensaje</label>
                <textarea rows={4} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-[#2E9BD6]" value={mensaje} onChange={e => setMensaje(e.target.value)} placeholder="¿En qué podemos ayudarte?" />
              </div>

              <input
                type="text"
                name="campo_extra"
                value={campoExtra}
                onChange={e => setCampoExtra(e.target.value)}
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }}
              />

              {error && <p className="text-xs text-red-600 font-semibold">{error}</p>}

              <button onClick={enviarContacto} disabled={loading} className="w-full bg-[#102A46] text-white font-bold py-3 rounded-xl hover:bg-[#0c2036] disabled:opacity-40 transition-all">
                {loading ? "Enviando..." : "Enviar mensaje"}
              </button>
            </div>
          )}
        </div>
      </section>

      <footer className="border-t border-gray-100 py-6">
        <p className="text-center text-xs text-gray-400">WareHausePlan © 2026</p>
      </footer>
    </div>
  );
};
